import type { Event } from '@patsnap/tahiti-core';
import type { FeatureInitResponse, FeatureKey, UserPlan } from '../types';

export const PermissionV2Service = Symbol.for('PermissionV2Service');

/**
 * PermissionV2 Service
 * 管理功能权限和配额信息
 */
export interface PermissionV2Service {
    /**
     * 功能权限数据变化事件
     */
    readonly onDataChange: Event<FeatureInitResponse>;

    /**
     * 初始化功能权限数据
     */
    initialize(options: { taskId: string, taskType: string }): Promise<void>;

    /**
     * 获取当前的功能权限数据
     */
    getFeatureData(): FeatureInitResponse | null;

    /**
     * 检查功能是否可用（不考虑用量限制）
     * @param featureKey 功能键值
     */
    isAvailable(featureKey: FeatureKey): boolean;

    /**
     * 检查功能是否有足够用量（未达到用量限制）
     * @param featureKey 功能键值
     */
    hasQuota(featureKey: FeatureKey): boolean;

    /**
     * 获取用户套餐信息
     */
    getUserPlan(): UserPlan | null;

    /**
     * 更新功能权限数据（用于后续刷新）
     */
    updateFeatureData(data: FeatureInitResponse): void;
}
